var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGenerateNewSecret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.411,
    height: 14.447,
    viewBox: "0 0 15.411 14.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(-23.222 -20.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M-5481,11251.857a7,7,0,0,1,1.4-9.353l-1.842.285a.413.413,0,0,1-.478-.353.434.434,0,0,1,.359-.483l3.251-.506a.417.417,0,0,1,.339.1.416.416,0,0,1,.141.319l-.048,3.291a.437.437,0,0,1-.1.274.444.444,0,0,1-.325.149.418.418,0,0,1-.415-.424l.031-2.09a6.007,6.007,0,0,0-1.478,8.23,5.757,5.757,0,0,0,6.463,2.48c.483-.127.718.237.576.528a.552.552,0,0,1-.293.254,5.46,5.46,0,0,1-2.054.381A6.606,6.606,0,0,1-5481,11251.857Zm9.988,2.031a.429.429,0,0,1-.144-.319l.048-3.291a.435.435,0,0,1,.107-.273.441.441,0,0,1,.325-.15.418.418,0,0,1,.416.424l-.031,2.088a6.007,6.007,0,0,0,1.478-8.229,5.761,5.761,0,0,0-6.466-2.48c-.48.127-.715-.237-.574-.528a.536.536,0,0,1,.294-.254,6.393,6.393,0,0,1,7.573,2.7,7,7,0,0,1-1.4,9.353l1.842-.285a.411.411,0,0,1,.475.351.431.431,0,0,1-.356.485l-3.251.506a.375.375,0,0,1-.066,0A.4.4,0,0,1-5471.014,11253.889Z",
    transform: "translate(5505.423 -11219.834)",
    fill: "#064764"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGenerateNewSecret);
export default __webpack_public_path__ + "static/media/action_generate_new_secret.0e157b35a2a9ec0b5ad2a57b149f0c4f.svg";
export { ForwardRef as ReactComponent };